import moment from 'moment';
import ReactGA from 'react-ga4';

/**
 * PageView - função de rastreamento de página do ReactGa.
 * @param {string} url
 * */
export function pageView(url) {
  if (process.env.REACT_APP_GA4_MEASUREMENTID) {
    ReactGA.set(
      {
        userId: localStorage.getItem('idUsuario'),
        dimension1: localStorage.getItem('cliente_cnpj_resumido'),
      },
      ['shipper']
    );
    ReactGA.send({ hitType: 'pageview', page: url });
  }
}

/**
 * Event - adicione um evento de rastreamento personalizado.
 * @param {string} categoria
 * @param {string} acao
 * @param {string} descricao
 * @deprecated - Use gtaEntrada ou gtaSaida
 * */
export function eventGA(categoria, acao, descricao) {
  if (process.env.REACT_APP_GA4_MEASUREMENTID) {
    ReactGA.event({
      category: categoria,
      action: acao,
      label: descricao,
      userId: localStorage.getItem('idUsuario'),
      dimension1: localStorage.getItem('cliente_cnpj_resumido'),
    });
  }
}

/**
 * gTagEntrada - Dispara um evento de entrada de fluxo para o Google Analytics.
 * @param {string} categoria
 * @param {string} acao
 * @param {string} descricao
 * @param {string} eventId
 * @return {void} void
 * */
export function gTagEntrada(acao, categoria, descricao, eventId) {
  if (process.env.REACT_APP_GA4_MEASUREMENTID) {
    ReactGA.gtag('event', acao, {
      event_category: categoria,
      event_label: descricao,
      profile: localStorage.getItem('profile'),
      userId: localStorage.getItem('idUsuario'),
      entrada: moment()
        .locale('pt-br')
        .format(),
      eventId,
    });
  }
}

/**
 * gTagSaida - Dispara um evento de saída de fluxo para o Google Analytics.
 * @param {string} categoria
 * @param {string} acao
 * @param {string} descricao
 * @param {string} eventId
 * @returns {void} void
 * */
export function gTagSaida(acao, categoria, descricao, eventId) {
  if (process.env.REACT_APP_GA4_MEASUREMENTID) {
    ReactGA.gtag('event', acao, {
      event_category: categoria,
      event_label: descricao,
      profile: localStorage.getItem('profile'),
      userId: localStorage.getItem('idUsuario'),
      saida: moment()
        .locale('pt-br')
        .format(),
      eventId,
    });
  }
}
